<template>
  <div
    class="mt-3 grid grid-gap-2 grid-cols-1 s:grid-cols-2 xl:grid-cols-5 lg:grid-cols-4 sm:grid-cols-3"
  >
    <template
      v-if="
        (isLoading || isLoading == undefined) &&
          !movies.hasOwnProperty('total_results')
      "
    >
      <skeleton-card-explore-movie
        v-for="(load, index) in Array(20).fill()"
        :key="index"
        :width="'md:w-11/12 sm:w-48 xs:w-11/12 w-full'"
      />
    </template>
    <template v-else>
      <template v-if="movies.results && movies.results.length">
        <div class="mt-8" v-for="popular in movies.results" :key="popular.id">
          <card-explore-movie
            :data="popular"
            :width="'md:w-11/12 sm:w-48 xs:w-11/12 w-full'"
          />
        </div>
      </template>
      <div v-else class="mt-8">
        <p>No results found</p>
      </div>
    </template>
  </div>
</template>

<script>
import SkeletonCardExploreMovie from "../Skeleton/Templates/SkeletonCardExploreMovie.vue";
export default {
  components: { SkeletonCardExploreMovie },
  name: "grid-view",
  props: {
    movies: {
      type: Object,
      required: true
    },
    isLoading: { type: Boolean, required: true, default: true }
  }
};
</script>
